module.exports = __webpack_public_path__ + "MaterialIcons-Regular.e79bfd88537def476913.eot";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/iconfont/MaterialIcons-Regular.eot
// module id = ../../../../../src/fonts/iconfont/MaterialIcons-Regular.eot
// module chunks = 3